import { whitelabelConfig as brandFallback } from '@/brands';
import {
  WHITELABEL_KEY_TO_BRAND_PATH,
  WHITELABEL_KEY_TO_CATEGORY,
} from '@/types/enums/WhitelabelConfig';
import type { AnyWhitelabelConfigKey } from '@/types/enums/WhitelabelConfig';
import type { WhitelabelConfigResponse } from '@/types/models/WhitelabelConfig';

export function getNestedValue(obj: Record<string, unknown>, path: string): unknown {
  return path.split('.').reduce<unknown>((acc, part) => {
    if (acc && typeof acc === 'object' && part in (acc as Record<string, unknown>)) {
      return (acc as Record<string, unknown>)[part];
    }
    if (typeof acc === 'string' && part === 'DEFAULT') {
      return acc;
    }
    return undefined;
  }, obj);
}

export function resolveWhitelabelValue<T>(
  config: WhitelabelConfigResponse | null,
  key: AnyWhitelabelConfigKey,
): T | undefined {
  const category = WHITELABEL_KEY_TO_CATEGORY[key];
  const apiVal = config?.[category]?.[key];
  if (apiVal !== undefined && apiVal !== null) {
    return apiVal as T;
  }

  const path = WHITELABEL_KEY_TO_BRAND_PATH[key];
  if (!path) return undefined;
  const fallback = getNestedValue(
    brandFallback as unknown as Record<string, unknown>,
    path,
  );
  return fallback as T | undefined;
}
